'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import { Container, TextWrapper, Card, Text, Link, StoreCardIcon, OpenHoursContainer, CircleBadge, PrimaryTextWrapper, StoreInformationContainer, ChevronIconContainer, InformationTextContainer, StoreCardContent, CircleBadgeNumber, StoreName, Ranking, MilesAway } from './elements';
import { colors } from '../../abstracts';
import { Star } from './Star';
import { useComponentDeprecation } from '../../util';

/** @deprecated */
export const StoreCard = /*#__PURE__*/forwardRef(({
  badgeColor = 'primary',
  storeNameSize = 4,
  showBadge,
  showChevron,
  showIcons,
  ranking,
  rankProvider,
  storeName,
  storeNumber,
  address,
  phoneNumber,
  openHours: OpenHours,
  milesAway,
  disabled,
  selected = false,
  type,
  chevronClassName,
  ...rest
}, fRef) => {
  useComponentDeprecation({
    name: 'StoreCard',
    version: 'v5',
    alternative: 'a StoreBlock inside the SimpleCard'
  });
  const isClickable = type === 'selection' || type === 'call-to-action';
  return /*#__PURE__*/React.createElement(Card, _extends({
    element: isClickable ? 'button' : 'div',
    type: type,
    selected: selected,
    disabled: disabled,
    padding: '1rem',
    tabIndex: 0
  }, rest), /*#__PURE__*/React.createElement(Container, {
    "data-aui": "store-card",
    ref: fRef
  }, /*#__PURE__*/React.createElement(StoreCardContent, null, storeName && /*#__PURE__*/React.createElement(PrimaryTextWrapper, null, showBadge && /*#__PURE__*/React.createElement(CircleBadge, {
    disabled: disabled,
    badgeColor: badgeColor
  }, /*#__PURE__*/React.createElement(CircleBadgeNumber, {
    storeNameSize: storeNameSize,
    weight: "heavy",
    size: 1,
    color: colors.white
  }, storeNumber)), /*#__PURE__*/React.createElement(StoreName, {
    storeNameSize: storeNameSize,
    showBadge: showBadge,
    weight: "feather",
    size: storeNameSize,
    color: disabled ? colors.disabledText : 'neutralDeepest'
  }, storeName)), ranking >= 0 && /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(Star, {
    disabled: disabled
  }), /*#__PURE__*/React.createElement(Ranking, {
    weight: "base",
    size: 2,
    color: disabled ? colors.disabledText : 'neutralDeepest'
  }, ranking), rankProvider && /*#__PURE__*/React.createElement(Ranking, {
    weight: "feather",
    size: 2,
    color: disabled ? colors.disabledText : 'neutralDeepest'
  }, rankProvider)), /*#__PURE__*/React.createElement(StoreInformationContainer, null, /*#__PURE__*/React.createElement("div", null, address && /*#__PURE__*/React.createElement(InformationTextContainer, null, showIcons && /*#__PURE__*/React.createElement(StoreCardIcon, {
    title: 'location-pin',
    color: disabled ? colors.disabledText : colors.black,
    src: 'location-pin'
  }), /*#__PURE__*/React.createElement(Text, {
    weight: "base",
    size: 1,
    color: disabled ? colors.disabledText : 'neutralDeepest'
  }, address)), milesAway && showChevron && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InformationTextContainer, null, showIcons && /*#__PURE__*/React.createElement(StoreCardIcon, {
    title: 'location-pin-miles',
    color: disabled ? colors.disabledText : colors.black,
    src: 'location-pin-miles'
  }), /*#__PURE__*/React.createElement(Text, {
    weight: "feather",
    size: 1,
    color: disabled ? colors.disabledText : 'neutralDeepest'
  }, milesAway, " miles away"))), phoneNumber && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InformationTextContainer, null, showIcons && /*#__PURE__*/React.createElement(StoreCardIcon, {
    title: 'Phone',
    color: disabled ? colors.disabledText : colors.black,
    src: 'phone'
  }), isClickable ? /*#__PURE__*/React.createElement(Text, {
    weight: "base",
    size: 1,
    color: disabled ? colors.disabledText : 'neutralDeepest'
  }, phoneNumber) : /*#__PURE__*/React.createElement(Link, {
    disabled: disabled,
    href: `tel:+${phoneNumber}`
  }, phoneNumber))))), OpenHours && /*#__PURE__*/React.createElement(OpenHoursContainer, null, /*#__PURE__*/React.createElement(InformationTextContainer, null, showIcons && /*#__PURE__*/React.createElement(StoreCardIcon, {
    title: 'Time',
    color: disabled ? colors.disabledText : colors.black,
    src: 'time'
  }), OpenHours), /*#__PURE__*/React.createElement(TextWrapper, null, !showChevron && milesAway && /*#__PURE__*/React.createElement(MilesAway, {
    weight: "base",
    size: 1,
    color: disabled ? colors.disabledText : 'neutralDeepest'
  }, milesAway, " mi")))), showChevron && /*#__PURE__*/React.createElement(ChevronIconContainer, null, /*#__PURE__*/React.createElement(StoreCardIcon, {
    className: chevronClassName,
    title: 'CardsNavigationChevronRight',
    color: disabled ? colors.disabledText : colors.black,
    src: 'cards-navigation-chevron-right',
    size: 'large'
  }))));
});